import type { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { isEmpty } from '@peloton/helpers/isEmpty';
import { isNil } from '@peloton/helpers/isNil';
import { redirect } from '@peloton/navigation';
import { getLocation } from '@peloton/redux/selectors';
import { toLoginRoute, toTagsLoginRoute } from '@members/pg-auth/urls';
import { getTagNameFromLocation } from '@members/tags/selectors';

export const loginRedirectSaga = function* (): SagaIterator {
  const tagName = yield select(getTagNameFromLocation);
  const location = yield select(getLocation);

  if (isNil(tagName) || isEmpty(tagName)) {
    // Use window.location rather than the Redux/history `location` selector.
    // The history object is created with `basename = '/<locale>'` so
    // `location.pathname` is already locale-stripped (e.g. '/home/' instead
    // of '/de-DE/home/'). Reading from window.location preserves the full
    // locale-prefixed path so the post-login redirect lands on the correct
    // locale page.
    const currentPath =
      typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : location.pathname + location.search;
    yield call(redirect, toLoginRoute(currentPath));
  } else {
    yield call(redirect, toTagsLoginRoute(tagName, location));
  }
};

export const homeRedirectSaga = function* () {
  yield call(redirect, '/');
};

export const notFoundRedirectSaga = function* () {
  yield call(redirect, '/404');
};
